module.exports = __webpack_public_path__ + "static/assets/b5f8889e91e6d51fc294dfd1125c1240.mp3";